import { Component, OnInit, ViewChild } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { DatePipe } from '@angular/common';

// import { DxDataGridModule, DxDataGridComponent } from 'devextreme-angular';
import { DxDataGridModule, DxDataGridComponent } from 'devextreme-angular';
import { SharedService } from '../../../../shared/shared.service';
import { UsefulToolsService } from '../../../../shared/other/usefultools.service';
import { TripService } from './trip.services';
import { TripDateService } from './trip-dates';
import { DataSource } from '@angular/cdk/table';
import { ignoreElements } from 'rxjs/operators';

import * as moment from 'moment';

@Component({
  selector: 'app-trips',
  templateUrl: './trips.component.html',
  styleUrls: ['./trips.component.css']
})
export class TripsComponent implements OnInit {

  @ViewChild(DxDataGridComponent) dataGrid: DxDataGridComponent;
  dataSource = [];
  dataSourceCell = [];
  arr = [];
  sessionId = sessionStorage.getItem('com-session-id');
  startDate;
  endDate;
  disableRefresh = false;
  counterTrips;

  arrColorRef = [
    'black',//
    'Firebrick',
    'Blue', //
    'ForestGreen',
    'Purple',
    'HotPink',//
    'Crimson',
    'DarkSlateBlue',
    'SeaGreen', //
    'DarkOrchid',
    'DarkGray'
  ];

  constructor(
    private httpclient: HttpClient,
    public sharedservice: SharedService,
    public trip: TripService,
    public date: DatePipe,
    public tripdateservice: TripDateService,
    private usefultoolsservice: UsefulToolsService
  ) { }

  formatDateString = this.sharedservice.dateFormatString;

  ngOnInit() {
    this.startDate = this.tripdateservice.getDate().startDate;
    this.endDate = this.tripdateservice.getDate().endDate;
    console.log(this.endDate);
    const tempStartDate = new Date(this.startDate);
    tempStartDate.setHours(0, 0, 0, 0);
    const tempEndDate = new Date(this.endDate);
    tempEndDate.setHours(23, 59, 59, 59);
    this.tripdateservice.setDates(tempStartDate, tempEndDate);
    this.onPageLoad();
    this.sharedservice.loadingActive = false;
  }

  refresh() {
    const tempStartDate = new Date(this.startDate);
    tempStartDate.setHours(0, 0, 0, 0);
    const tempEndDate = new Date(this.endDate);
    tempEndDate.setHours(23, 59, 59, 59);

    // Check if To date it earlier than From date
      if (tempStartDate > tempEndDate) {
        this.usefultoolsservice.notify('error', 'From date cannot be later than To date');
        return;
      }

    this.tripdateservice.setDates(tempStartDate, tempEndDate);
    this.disableRefresh = true;
    this.onPageLoad();
    this.sharedservice.loadingActive = false;
  }

  onPageLoad() {
    let start = this.tripdateservice.getDate().startDate
    start = moment(start).format('YYYY-MM-DD');
    let end = this.tripdateservice.getDate().endDate
    end = moment(end).format('YYYY-MM-DD');

    this.sharedservice.loadingActive = true;
    const postSession = {
      SessionID: this.sessionId,
      startDate: start,
      endDate: end
    };
    console.log(postSession);
    this.httpclient.post<any>(`${this.sharedservice.URLnode}/utData`, postSession).subscribe(Response => {
      this.dataSource = Response.recordset == null ? [] : Response.recordset;
      console.log(this.dataSource);
      this.dataGrid.instance.refresh();
      this.sharedservice.loadingActive = false;
      this.counterTrips = this.dataSource.length;
    });
    this.sharedservice.loadingActive = false;
  }

  clickevent(data) {
    sessionStorage.setItem('trips-id', data);
    this.trip.setTrip(1);
  }

  clickNew() {
    this.trip.setTrip(0);
  }

  sendSMSDriver() {
    this.sharedservice.loadingActive = true;
    console.log('0 is on');
    const getData = this.getSelectedRowsData();
    let dataString = '';
    getData.forEach(element => {
      dataString += element.ID + ',';
    });
    dataString = dataString.slice(0, dataString.length - 1);

    let arrayString = dataString.split(',');

    arrayString.forEach(element => {
      const postThis = {
        SessionID: this.sessionId,
        TripID: `${element}`,
        SMSTarget: 'DRIVER'
      };
      console.log(postThis);
      // this.httpclient.post<any>(`${this.sharedservice.URL}/utSendSMS`, postThis).subscribe(Response => {
      //   console.log(Response);
      //   if (Response.utSendSMS_response.RESULT === 'OK') {
      //     this.usefultoolsservice.notify('success', this.sharedservice.notificationMessages.smsSent);
      //     console.log('0 is off');
      //   } else {
      //     this.usefultoolsservice.notify('error', `Error: ${Response.utSendSMS_response.ServiceResults[0].ERRORDESCRIPTION}`);
      //     console.log('0 is off');
      //   }
      // });
      this.driverSMS(postThis)
    });
  }

  async driverSMS(postThis) {
    let sms = await new Promise(resolve => {
      this.httpclient.post<any>(`${this.sharedservice.URL}/utSendSMS`, postThis).subscribe(Response => {
        console.log(Response);
        if (Response.utSendSMS_response.RESULT === 'OK') {
          this.usefultoolsservice.notify('success', this.sharedservice.notificationMessages.smsSent);
          resolve(Response);
        } else {
          this.usefultoolsservice.notify('error', `Error: ${Response.utSendSMS_response.ServiceResults[0].ERRORDESCRIPTION}`);
          resolve(Response);
        }
      });
    });
    console.log(sms);
    if(sms){
      this.sharedservice.loadingActive = false;
      console.log('now 0 is of');
    }
  }

  sendSMSClient() {
    this.sharedservice.loadingActive = true;
    const getData = this.getSelectedRowsData();
    let dataString = '';
    getData.forEach(element => {
      dataString += element.ID + ',';
    });
    dataString = dataString.slice(0, dataString.length - 1);

    const postThis = {
      SessionID: this.sessionId,
      TripID: dataString,
      SMSTarget: 'CLIENT'
    };
    this.httpclient.post<any>(`${this.sharedservice.URL}/utSendSMS`, postThis).subscribe(Response => {
      if (Response.utSendSMS_response.RESULT === 'OK') {
        this.usefultoolsservice.notify('success', this.sharedservice.notificationMessages.smsSent);
      } else {
        this.usefultoolsservice.notify('error', `Error: ${Response.utSendSMS_response.ServiceResults[0].ERRORDESCRIPTION}`);
      }
    });
    this.sharedservice.loadingActive = false;
  }

  sendEmailClient(){
    this.sharedservice.loadingActive = true;
    const getData = this.getSelectedRowsData();
    let dataString = '';
    getData.forEach(element => {
      dataString += element.ID + ',';
    });
    dataString = dataString.slice(0, dataString.length - 1);

    let arrayString = dataString.split(',');

    arrayString.forEach(element => { 
      const postThis = {
        SessionID: this.sessionId,
        TripID: `${element}`
      };

      this.httpclient.post<any>(`${this.sharedservice.URLnode}/utSendEmail`, postThis).subscribe(Response => {
        if (Response.result === 'success') {
              this.usefultoolsservice.notify('success', this.sharedservice.notificationMessages.emailSent);
            } else {
              this.usefultoolsservice.notify('error', `Error: ${Response.utSendEmail_response.ServiceResults[0].ERRORDESCRIPTION}`);
            }
      });
    });
    this.sharedservice.loadingActive = false;
  }

  // on hold took it of front end
  sendEmailDriver() {
    // const getData = this.getSelectedRowsData();
    // let dataString = '';
    // getData.forEach(element => {
    //   dataString += element.ID + ',';
    // });
    // dataString = dataString.slice(0, dataString.length - 1);

    // const postThis = {
    //   SessionID: this.sessionId,
    //   TripID: dataString
    // };
    // this.httpclient.post<any>(`${this.sharedservice.URL}/utSendEmail`, postThis).subscribe(Response => {
    //   if (Response.utSendSMS_response.RESULT === 'OK') {
    //     this.usefultoolsservice.notify('success', this.sharedservice.notificationMessages.smsSent);
    //   } else {
    //     this.usefultoolsservice.notify('error', `Error: ${Response.utSendSMS_response.ServiceResults[0].ERRORDESCRIPTION}`);
    //   }
    // });
  }

  getSelectedRowsData () {
      return this.dataGrid.instance.getSelectedRowsData();
  }

  getDriverColor(pDriverName) {
    const driver = this.dataSource.filter(element => element.FirstDriver == pDriverName);
    if (driver.length > 0 && driver !== undefined && driver !== null) {
      return this.arrColorRef[driver[0]['FirstDriver_ID'] % 10];
    } else {
      return '';
    }
  }
}
